<template>
  <div id="invite">
      <div class="horn">每邀请一个新人注册并购买蝉鸣产品套餐，可获赠50.00美金消费券。活动无上限，赶紧复制下方链接邀请好友吧！</div>
      <div class="inviteCode">
        <div class="link">
          <!-- <a :href="inviteLink" target="_blank">{{inviteLink}}</a> -->
          {{inviteLink}}
        </div>
        <div class="button_box">
          <el-button type="primary" 
              v-clipboard:copy="inviteLink" 
              v-clipboard:success="()=>$message({showClose: true,message:'复制成功！',type:'success'})" 
              v-clipboard:error="()=>$message({showClose: true,message:'复制失败，请手动复制',type:'error'})">点击复制</el-button>
        </div>
      </div>
      <div class="box">
        <div class="title">邀请历史</div>
        <div class="list">
          <el-table
            :data="list"
            tooltip-effect="dark"
            style="width: 100%"
          >
              <el-table-column prop="email" label="邀请好友"></el-table-column>
              <el-table-column prop="setMealName" label="好友购买套餐"></el-table-column>
              <el-table-column prop="lastUpdateTime" label="获得奖励时间"></el-table-column>
              <el-table-column label="获得积分">
                  <template slot-scope="scope">
                      $<span>{{((scope.row.rewardPrice || 0) *1 ).toFixed(2)}}</span>
                  </template>
              </el-table-column>
          </el-table>
        </div>
      </div>
  </div>
</template>
<style lang="scss">
@import "../assets/template/css/bootstrap.min.css";
@import "../assets/template/css/style.css";
@import "../assets/template/css/responsive.css";
@import "../assets/template/css/colors.css";
@import "../assets/template/css/animate.css";
#invite{
  .horn{
    line-height:70px;
    height:70px;
    background:#fff url("../assets/img2/horn.png") no-repeat 10px center;
    padding-left:50px;
    color:#333;
  }
  .inviteCode{
    display:flex;
    justify-content: space-between;
    align-items: center;
    background:#fff;
    margin:15px 0;
    padding:8px 15px;
  }
  .box{
    .title{
      font-weight: bold;
      margin-bottom:8px;
    }
    .list{
      background:#fff;
      padding:15px;
    }
  }
}
@media screen and (max-width: 600px){
    #invite{
      .horn{
        margin-top:15px;
        line-height: 22px;
        padding-top: 8px;
        padding-bottom: 8px;
        height:unset;
      }
    }
}
</style>

<script>
import server from "@/public/service"
import {SUCCESS_CODE} from "@/public/state";
import getInterfaceData from "@/public/service/getInterfaceData";
// import moment from "moment";

export default {
  title: "Dingo Group",	
  data() {
    return {
        mealInfo:{},
        list:[],
        inviteCode:"",
        inviteLink:"",
        timezone:"",
    };
  },
  methods: {
      getInviteList(){
          var params = {
            userId: this.$store.state.userInfo.id,
            inviteCode: this.$store.state.userInfo.inviteCode,
            size:999,
            current:1,
          };
          server.getInviteList(params).then(data=>{
              if(data.reCode === SUCCESS_CODE){
                  var result = getInterfaceData(data);
                  result.records.forEach(v=>{
                      v.firstUpdatetime = toCurrentTime(v.firstUpdatetime,this.timezone);
                  });
                  this.list = result.records;
              };
          });
      },
  },
  created(){
    this.getInviteList();
    this.inviteCode = this.$store.state.userInfo.inviteCode;
    this.inviteLink = location.origin + "/#/register?code=" + (this.inviteCode || "");
    this.timezone = this.$store.state.userInfo.timezone;
  }
};
</script>
